import styled from "styled-components";
import { themeColor } from "ui/theme";

const RoundedRadioButton = ({
  label,
  id,
  isSelected,
  onSelected,
  disabled = false,
  ...rest
}) => {
  return (
    <RoundedRadioButtonContainer onClick={() => !disabled && onSelected(id)}>
      <Radio
        id={id}
        type="radio"
        isSelected={isSelected}
        disabled={disabled}
        {...rest}
      />
      <Label htmlFor={id} disabled={disabled}>
        {label}
      </Label>
    </RoundedRadioButtonContainer>
  );
};

const RoundedRadioButtonContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;
const Radio = styled.input`
  appearance: none;
  margin: 0;
  width: 20px;
  height: 20px;
  border: 2px solid ${themeColor("blue")};
  border-radius: 50%;
  transition: all 0.1s ease-in-out;
  background-color: ${({ isSelected }) =>
    isSelected ? themeColor("blue") : "transparent"};

  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    margin: 2px;
  }

  &:hover::after {
    background-color: ${themeColor("blue")};
  }
`;

const Label = styled.label`
  font-weight: 600;
  font-size: 1rem;
  color: ${themeColor("black")};
  cursor: default;
  ${({ disabled }) =>
    disabled &&
    `
    color: ${themeColor("lightGrey")};
    cursor: not-allowed;
    &::after {
      margin-left: 8px;
      width: 12px;
      height: 15px;
      display: inline-block;
      content: " ";
      background-color: ${themeColor("blue")};
    }
  `}
`;

export { RoundedRadioButton };
